import React from "react";
import { Button } from "./Button";
import { ButtonProps } from "./types";
import { cn } from "../../lib/utils";

export interface IconButtonProps extends Omit<ButtonProps, "size"> {
  size?: "sm" | "md" | "lg";
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, variant, size = "md", ...props }, ref) => {
    const sizeClasses: Record<string, string> = {
      sm: "h-8 w-8",
      md: "h-10 w-10",
      lg: "h-12 w-12",
    };

    return (
      <Button
        ref={ref}
        variant={variant}
        className={cn(
          "p-0 flex items-center justify-center",
          sizeClasses[size as keyof typeof sizeClasses],
          className
        )}
        {...props}
      />
    );
  }
);

IconButton.displayName = "IconButton";
